import { css } from 'lit';

export const DxoStylesDark = css`
  :host([theme="dark"]) {
    color: hsl(0, 0%, 88%);
  }

  :host([theme="dark"]) table {
    background-color: hsl(0, 0%, 7%);
    color: hsl(0, 0%, 88%);
  }

  :host([theme="dark"]) th {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .first-row {
    border-top-color: white;
  }

  :host([theme="dark"]) td {
    border-color: hsl(0, 0%, 21%);
    color: hsl(0, 0%, 88%);
  }

  :host([theme="dark"]) .grv-table__body .grv-table__row:last-child .grv-table__cell,
  :host([theme="dark"]) .grv-table__body .grv-table__row:last-child .grv-table__header {
    border-bottom-color: hsl(0, 0%, 21%);
  }

  :host([theme="dark"]) tr:hover td {
    background-color: hsl(0, 0%, 12%);
  }
`;
